jQuery(document).ready(function () {
    let siteHeader = document.querySelector('#site-header');
    let body = document.querySelector('body');
    let openButton = siteHeader.querySelector('#hamburger-menu-button .open');
    let closeButton = siteHeader.querySelector('#hamburger-menu-button .close');
    let menuItems = siteHeader.querySelectorAll('.menu>li>a');
    let firstMenuItem = menuItems[0];
    let lastMenuItem = menuItems[menuItems.length - 1];

    let searchInput = siteHeader.querySelector('.main-nav #search-header-input');
    //let searchButton = siteHeader.querySelector('.main-nav button[type="submit"]');

    if (openButton || closeButton) {
        openButton.addEventListener('click', openMobileMenu);
        closeButton.addEventListener('click', closeMobileMenu);
        closeButton.addEventListener('keydown', focusSearchInput);
        // searchInput.addEventListener('keydown', focusLastMenuItem);
        // searchButton.addEventListener('keydown', focusCloseMenu);
    }

    function openMobileMenu() {
        body.classList.add('is-menu-on');
        siteHeader.classList.add('is-menu-on');
        openButton.setAttribute('aria-expanded', 'true');
        firstMenuItem.focus();
    }

    function closeMobileMenu() {
        body.classList.remove('is-menu-on');
        siteHeader.classList.remove('is-menu-on');
        openButton.setAttribute('aria-expanded', 'false');
    }

    function focusLastMenuItem(e) {
        if (e.key === 'Tab' && e.shiftKey === true) {
            e.preventDefault();
            lastMenuItem.focus();
        }
    }

    function focusSearchInput(e) {
        if (e.key === 'Tab' && e.shiftKey === true) {
            e.preventDefault();
            searchInput.focus();
        }
    }

    function focusCloseMenu(e) {
        if (e.key === 'Tab' && e.shiftKey === false) {
            e.preventDefault();
            closeButton.focus();
        }
    }

    jQuery('.open-sub-menu').click(function () {
        let parent = jQuery(this).closest('.menu-item');
        parent.toggleClass('visible');
    });
});

ChangeBackgroundMenu()

function ChangeBackgroundMenu() {

    const topHeaderNav = document.querySelector('.top-header-nav');
    const siteHeader = document.querySelector('#site-header');
    const siteHeaderHeight = siteHeader.offsetHeight;
    const scrollTrigger = document.querySelector('.header-trigger');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                siteHeader.classList.add('header-black');
                topHeaderNav.style.marginBottom = siteHeaderHeight + 'px';
            } else {
                siteHeader.classList.remove('header-black');
                topHeaderNav.style.marginBottom = 0;
            }
        });
    }, {root: null, threshold: 0});

    observer.observe(scrollTrigger); // Observe the main element

}
